import { render, staticRenderFns } from "./recebimento.vue?vue&type=template&id=449291a5"
import script from "./recebimento.vue?vue&type=script&lang=js"
export * from "./recebimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports